export default __webpack_public_path__ + "static/media/Robo_BookWorm_logo_v2-03.aa02c5e6.png";